<template>
  <llp-page
    id="datatble-page"
    :menuOptions="menuOptions"
    :pageName="pageName"
    :userName="userName"
  >
    <template v-slot:body>
      <div class="rental-row">
        <div class="card m-4 m-lg-3">
          <div class="card-body">
            <div class="row p-0 align-items-center rental-payment">
              <div
                class="col mt-4"
                :class="{ 'mb-5 mb-sm-0': !showAddUserButton }"
              >
                <h4>{{ capitalizedRole }} List</h4>
              </div>
              <div
                class="col-lg-2 col-md-3 col-sm-4 col-12 d-flex justify-content-end add-btn"
                v-if="showAddUserButton"
              >
                <llp-button
                  :load-spinner="showaddUserSpinner"
                  classNames="btn-secondary text-nowrap new-btn"
                  type="button"
                  @click:button="addUser()"
                >
                  <i class="fa-solid fa-plus"></i>
                  Add {{ capitalizedRole }}
                </llp-button>
              </div>
            </div>
            <div class="row">
              <div class="col table-data position-relative">
                <div v-if="loading" class="loader-overlay">
                  <div class="spinner"></div>
                </div>
                <llp-datatable
                  ref="usersTable"
                  :columns="columns"
                  :data="users"
                  :lazy="true"
                  :paginator="true"
                  :totalRecords="totalRecords"
                  scrollable
                  @onPageChange="onPageChange"
                >
                  <template #status="{ data }">
                    <div class="text-center">
                      <button
                        v-if="data.status === 'Inactive'"
                        class="btn btn-danger m-1"
                        @click="updateStatus(data.id, data.status)"
                      >
                        Inactive
                      </button>
                      <button
                        v-else
                        class="btn btn-success m-1"
                        @click="updateStatus(data.id, data.status)"
                      >
                        Active
                      </button>
                    </div>
                  </template>
                  <template #actions="{ data }">
                    <div class="text-center">
                      <button
                        class="btn btn-secondary m-1 new-btn"
                        @click="ViewUserDetails(data.id)"
                      >
                        <i class="fa fa-eye"></i>
                      </button>
                      <button
                        class="btn btn-secondary m-1 new-btn"
                        @click="EditUserDetails(data.id)"
                      >
                        <i class="fa fa-edit"></i>
                      </button>
                      <button
                        class="btn btn-secondary m-1 new-btn"
                          @click="showDeleteConfirmation(data.id)"
                      >
                        <i class="fa fa-trash"></i>
                      </button>
                    </div>
                  </template>
                </llp-datatable>
              </div>
            </div>
          </div>
        </div>
      </div>
       <div class="modal fade" id="deleteConfirmationModal" tabindex="-1" aria-labelledby="deleteConfirmationModalLabel" aria-hidden="true">
        <div class="modal-dialog modal-dialog-centered">
          <div class="modal-content">
            <div class="modal-header">
              <h5 class="modal-title" id="deleteConfirmationModalLabel">Confirm Delete</h5>
              <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
            </div>
            <div class="modal-body">
              Are you sure you want to delete this {{ role }}?
            </div>
            <div class="modal-footer">
              <button type="button" class="btn btn-secondary" data-bs-dismiss="modal">Cancel</button>
              <button type="button" class="btn btn-danger" @click="confirmDelete">Delete</button>
            </div>
          </div>
        </div>
      </div>
    </template>
  </llp-page>
  <llp-toast ref="toast"></llp-toast>
</template>

<script>
import NetworkService from "@/services/network.service";
import ErrorService from "../../../services/error.service";
import { Modal } from 'bootstrap';
export default {
  data() {
    return {
      loading: false,
      loginUserId: localStorage.getItem("User_id"),
      login_user_role_id: localStorage.getItem("role_id"),
      filteredUserDetails: [],
      role: this.$route.params.role,
      roleId: "",
      users: "",
      currentPage: 1,
      perpage: 10,
      totalRecords: 0,
       userToDelete: null,
      deleteModal: null,
      columns: [
        { field: "s_no", className: "text-center", header: "id" },
        { field: "name", className: "text-center", header: "Name" },
        { field: "user_name", header: "User Name", className: "text-center" },
        { field: "email", header: "Email", className: "text-center" },
        { field: "mobile", header: "Mobile", className: "text-center" },
        {
          field: "wallet_balance",
          header: "Wallet Balance",
          className: "text-center",
        },
        {
          field: "status",
          header: "Status",
          className: "text-center",
          slot: "status",
          isCustomized: true,
          customizeName: "status",
        },
        {
          field: "action",
          header: "Action",
          body: "actions",
          className: "text-center",
          isCustomized: true,
          customizeName: "actions",
        },
      ],
    };
  },

  computed: {
    capitalizedRole() {
      return this.role.charAt(0).toUpperCase() + this.role.slice(1);
    },
    showAddUserButton() {
      return !(
        this.login_user_role_id == 1 &&
        (this.role === "distributor" || this.role === "retailer")
      );
    },
  },

watch: {
  "$route.params.role": function (newRoleName) {
    this.role = newRoleName;
    this.currentPage = 1;
    this.perpage = 10;

    if (this.$refs.usersTable) {
        if (typeof this.$refs.usersTable.resetPaginator === 'function') {
            this.$refs.usersTable.resetPaginator();
        } else if (typeof this.$refs.usersTable.setPage === 'function') {
            this.$refs.usersTable.setPage(1);
        } 
    }
    this.setRoleIdAndFetch();
  },
},

  mounted() {
    this.setRoleIdAndFetch();
     this.deleteModal = new Modal(document.getElementById('deleteConfirmationModal'));
  },

  beforeRouteUpdate(to, from, next) {
    this.role = to.params.role;
    next();
  },

  methods: {
    setRoleIdAndFetch() {
      if (this.role == "admin") {
        this.roleId = 2;
      } else if (this.role == "distributor") {
        this.roleId = 3;
      } else if (this.role == "retailer") {
        this.roleId = 4;
      } else {
        this.roleId = "";
      }

      if (this.roleId) {
        this.fetchingUserDetails();
      }
    },
    async updateStatus(id, status) {
      try {
        const mappedStatus = status === "Inactive" ? 1 : 0;
        const response = await NetworkService.post(`/status-change/${id}`, {
          status: mappedStatus,
        });
        this.$refs.toast.show(response.data.message);
        this.fetchingUserDetails();
      } catch (error) {
        if (error.message) {
          this.$refs.toast.show(
            "Please contact superadmin,amdin,retialer",
            "error"
          );
        } else {
          this.$refs.toast.show(ErrorService.getErrorMessages(error), "error");
        }
      }
    },
    onPageChange(event) {
      const { first, rows } = event;
      this.currentPage = first / rows + 1;
      this.perpage = rows;
       this.loading = true; 
      this.fetchingUserDetails(this.currentPage, this.perpage);
    },
    async fetchingUserDetails() {
      try {
        const requestData = {
          page: this.currentPage,
          per_page: this.perpage,
        };
            this.loading = true; 
        const userResponse = await NetworkService.get(
          `/user-list-by-role/${this.roleId}/${this.loginUserId}`,
          requestData
        );
        const userData = userResponse.related_users || [];
        const startIndex = (this.currentPage - 1) * this.perpage;
        this.users = userData.map((user, index) => {
          return {
            s_no: startIndex + index + 1,
            name: user.name,
            user_name: `${user.name} (${user.username})`,
            email: user.email,
            mobile: user.mobile,
            state: user.state || "N/A",
            wallet_balance: user.wallet || 0,
            status: user.status == 1 ? "Active" : "Inactive",
            parent_id: user.parent_id,
            id: user.id,
          };
        });
        this.loading = false;
        this.totalRecords = userResponse.pagination.total;
      } catch (error) {
        this.loading = false;
        this.$refs.toast.show("Unable to fetch the user details.", "error");
      }
    },

    addUser() {
      this.$router.push(`/add-user/${this.role}`);
    },

    EditUserDetails(id) {
      this.$router.push({
        name: "EditUserDetails",
        params: { role: this.role, id },
      });
    },

    ViewUserDetails(id) {
      this.$router.push({
        name: "ViewUserDetails",
        params: { role: this.role, id },
      });
    },
  showDeleteConfirmation(id) {
      this.userToDelete = id;
      this.deleteModal.show();
    },
   async confirmDelete() {
      try {
        if (!this.userToDelete) return;
        const response = await NetworkService.post(`/user-delete/${this.userToDelete}`);
        this.$refs.toast.show(response.data.message);
        this.fetchingUserDetails();
      } catch (error) {
        this.$refs.toast.show(ErrorService.getErrorMessages(error), "error");
      } finally {
        this.deleteModal.hide();
        this.userToDelete = null;
      }
    },
  },
};
</script>
